import { createSlice } from '@reduxjs/toolkit';
import { levels } from '@utils/constants';
import { createIndependentStore } from '@utils/react';

const initialState = {
  title: undefined,
  levels: [],
  subjects: []
};
const createCourseSlice = createSlice({
  name: "course-builder/create",
  initialState,
  reducers: {
    setTitle(state, action) {
      state.title = action.payload;
    },
    toggleSubject(state, action) {
      const indexOf = state.subjects.indexOf(action.payload);
      if (indexOf !== -1) {
        state.subjects.splice(indexOf, 1);
      } else {
        state.subjects.push(action.payload);
        state.subjects.sort((a, b) => a.localeCompare(b, "da-DK", {
          numeric: true
        }));
      }
    },
    replaceSubjects(state, action) {
      state.subjects = action.payload;
    },
    toggleLevel(state, action) {
      const indexOf = state.levels.indexOf(action.payload);
      if (indexOf !== -1) {
        state.levels.splice(indexOf, 1);
      } else {
        state.levels.push(action.payload);
        state.levels.sort((a, b) => levels.indexOf(a) - levels.indexOf(b));
      }
    },
    replaceLevels(state, action) {
      state.levels = action.payload;
    },
    reset(state) {
      state.levels = initialState.levels;
      state.subjects = initialState.subjects;
      state.title = initialState.title;
    }
  }
});
const createStore = createIndependentStore(createCourseSlice);

export { createCourseSlice, createStore };
//# sourceMappingURL=_create-drawer.state.js.map
